var _line, _line2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTimer = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, props), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 10,
  x2: 14,
  y1: 2,
  y2: 2
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  x1: 12,
  x2: 15,
  y1: 14,
  y2: 11
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 14,
  r: 8
})));
export default SvgTimer;